import dayjs from "dayjs";

export const convertToDates = (dateType: string, customDateRange: any) => {
  try {
    switch (dateType) {
      case "Month to Date":
        return {
          from: dayjs().startOf("month").format("YYYY-MM-DD"),
          to: dayjs().format("YYYY-MM-DD"),
        };
      case "Quarter to Date":
        return {
          from: dayjs()
            .subtract(3, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          to: dayjs().format("YYYY-MM-DD"),
        };
      case "Year to Date":
        return {
          from: dayjs().startOf("year").format("YYYY-MM-DD"),
          to: dayjs().format("YYYY-MM-DD"),
        };
      default:
        if (!customDateRange)
          return {
            from: dayjs()?.format("YYYY-MM-DD"),
            to: dayjs()?.format("YYYY-MM-DD"),
          };
        return {
          from: dayjs(customDateRange[0]).format("YYYY-MM-DD"),
          to: dayjs(customDateRange[1]).format("YYYY-MM-DD"),
        };
    }
  } catch (error) {
    return {
      from: dayjs()?.format("YYYY-MM-DD"),
      to: dayjs()?.format("YYYY-MM-DD"),
    };
  }
};

export const timeStringToSeconds = (hhmm: string): number => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 3600 + m * 60;
};

export const secondsToTimeString = (seconds: number, fixed = 0): string => {
  const h = Math?.floor(seconds / 3600)?.toFixed(fixed);
  const m = Math?.floor((seconds % 3600) / 60)?.toFixed(fixed);
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
};

export const CustomJsonParse = (data: any, depth = 0, maxDepth = 0): any => {
  if (depth > maxDepth) return data;

  try {
    if (typeof data === "string") {
      const parsed = JSON.parse(data);
      return CustomJsonParse(parsed, depth + 1, maxDepth);
    }

    if (Array.isArray(data)) {
      return data.map((item) => CustomJsonParse(item, depth + 1, maxDepth));
    }

    if (typeof data === "object" && data !== null) {
      const result: any = {};
      for (const key of Object.keys(data)) {
        result[key] = CustomJsonParse(data[key], depth + 1, maxDepth);
      }
      return result;
    }

    return data;
  } catch (error) {
    return data;
  }
};

// timelog
export const secondsToHHMM = (totalSeconds: number) => {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

export const to12HourTime = (time?: string): string => {
  if (!time || !time.includes(":")) return "--:--";

  const [h, m] = time.split(":");
  let hour = parseInt(h, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${String(hour).padStart(2, "0")}:${m} ${ampm}`;
};
